import React, { useState } from "react";

/**
 * Compact avatar chip for the dashboard header — shows the user's profile
 * picture (from Google OAuth) with a first-name label. Falls back to initials
 * on missing/broken images.
 */
export default function UserChip({ user }) {
  const [imgError, setImgError] = useState(false);
  if (!user) return null;

  const firstName = (user.name || user.email || "").split(" ")[0].split("@")[0];
  const initials = firstName ? firstName[0].toUpperCase() : "?";
  const showImage = user.picture && !imgError;

  return (
    <div
      className="hidden sm:inline-flex items-center gap-2 pl-1 pr-3 py-1 rounded-full border transition-colors"
      style={{
        borderColor: "rgba(255,255,255,0.10)",
        backgroundColor: "rgba(255,255,255,0.03)",
      }}
      title={`Signed in as ${user.email}`}
      data-testid="user-chip"
    >
      {showImage ? (
        <img
          src={user.picture}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
          className="w-6 h-6 rounded-full object-cover"
          data-testid="user-chip-avatar"
        />
      ) : (
        <div
          className="w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold text-black"
          style={{ backgroundColor: "#7BD3CE" }}
          data-testid="user-chip-initials"
        >
          {initials}
        </div>
      )}
      <span className="text-sm text-white/75 font-medium" data-testid="user-chip-name">
        {firstName}
      </span>
    </div>
  );
}
